import React from "react";
import styled, { css } from "styled-components";
import { Col, Container, Row } from "react-bootstrap";

import Spacer from "./Spacer";
import Text from "./Text";
import { mediaQuery } from "../utils";

type FilmCoverProps = {
  additionalInfo?: string;
  director: string;
  name: string[] | string;
  url: string;
  year: string[] | string;
};

const FilmCoverRoot = styled.div<{ url: string }>`
  background-color: #000;
  background-image: ${(props) => `url(${props.url})`};
  background-repeat: no-repeat;
  background-size: cover;
  height: 68vh;
  opacity: 0.6;
  padding: 40px 0;
  position: absolute;
  width: 100%;

  ${mediaQuery(
    "phone",
    css`
      height: 26vh;
      max-height: 26vh;
    `,
  )}

  ${mediaQuery(
    "desktop",
    css`
      max-height: 68vh;
    `,
  )}
`;

const FilmCoverText = styled(Text)`
  ${mediaQuery(
    "phone",
    css`
      font-size: 16px;
    `,
  )}
`;

const FilmCoverWrapper = styled.div`
  background-color: #000;

  ${mediaQuery(
    "phone",
    css`
      font-size: 18px;
      height: 26vh;
    `,
  )}

  ${mediaQuery(
    "desktop",
    css`
      height: 68vh;
    `,
  )}
`;

const FilmCoverContainer = styled(Container)`
  padding: 40px 0;
  position: relative;
  z-index: 10;

  ${mediaQuery(
    "phone",
    css`
      padding: 40px 40px;
    `,
  )}
`;

const renderDangerousHTML = (value: string | undefined) =>
  (value ? <span dangerouslySetInnerHTML={{ __html: value }} /> : null);

const FilmCover: React.FC<FilmCoverProps> = ({
  additionalInfo,
  director,
  name,
  url,
  year,
}) => {
  const names = Array.isArray(name) ? name : [name];

  const directors = Array.isArray(director) ? director : [director];

  const years = Array.isArray(year) ? year : [year];

  return (
    <FilmCoverWrapper>
      <FilmCoverRoot url={url} />
      <FilmCoverContainer>
        <Row>
          <Col lg={7} md={7} sm={7} xs={7}>
            <FilmCoverText inverted size={64}>
              {renderDangerousHTML(names[0])}
              {names[1] && (
                <>
                  <Spacer size={10} />
                  {renderDangerousHTML(names[1])}
                  {renderDangerousHTML(directors[1])}
                </>
              )}
              <Spacer size={10} />
              {renderDangerousHTML(directors[0])}
            </FilmCoverText>
          </Col>
          <Col lg={5} md={5} sm={5} style={{ textAlign: "right" }} xs={5}>
            <FilmCoverText inverted size={54}>
              <div style={{ display: "grid" }}>
                {additionalInfo && <span>{additionalInfo}</span>}
                <span>{years[0]}</span>
                {years[1] && (
                  <>
                    <Spacer size={10} />
                    <span>{years[1]}</span>
                  </>
                )}
              </div>
            </FilmCoverText>
          </Col>
        </Row>
      </FilmCoverContainer>
    </FilmCoverWrapper>
  );
};

export default FilmCover;
